import { SlashStyle } from './Style'

function Slash() {
  // eslint-disable-next-line react/jsx-no-comment-textnodes
  return <SlashStyle>//</SlashStyle>
}

export { Slash }
